import { createFileRoute } from '@tanstack/react-router';
import AccountPasswordPage from '~/components/Auth/AccountPassword/AccountPasswordPage';

export const Route = createFileRoute('/_public/account-password')({
  component: AccountPasswordPage,
});
